'use client'

import { css } from '@lastbrand/web-ui-styled-system/css'

import LoaderSVG from '@src/quince-components/src/atoms/loaderWrapper/LoaderSVG'

import type { LoaderOverlayWrapperDSProps } from './loader-overlay-wrapper-ds.types'

const overlayWrapperClass = css({
  pointerEvents: 'none',
  opacity: 0.5,
  position: 'relative',
})

const overlaySurfaceClass = css({
  position: 'absolute',
  inset: 0,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: 1001,
  pointerEvents: 'none',
})

export function LoaderOverlayWrapperDS({ overlayClasses, isLoading, children }: LoaderOverlayWrapperDSProps) {
  const wrapperClassName = overlayClasses ? overlayClasses : overlayWrapperClass

  return (
    <div className={isLoading ? wrapperClassName : ''}>
      {children}
      <div className={overlaySurfaceClass} style={{ display: isLoading ? 'flex' : 'none' }} aria-hidden={!isLoading}>
        <LoaderSVG />
      </div>
    </div>
  )
}
